import { IconButton } from '@material-ui/core';
import { OpenInNew } from '@material-ui/icons';
import { memo } from 'react';

import useRole from '../hooks/useRole';
import { getExternalPackageLink } from '../modules/external-detail-link';
import { SourceType } from '../modules/generated/api';
import { getLabel, sources } from '../modules/labels';
import UserRole from '../types/UserRoles';

import ActionTooltip from './ActionTooltip';

type ActionExternalDetailLinkProps = {
  source?: SourceType;
  packageId?: string;
  carId?: string;
  offerId?: string;
  size?: 'small' | 'medium';
};

const ActionExternalPackageLink = ({
  source,
  packageId,
  carId,
  offerId,
  size = 'small',
}: ActionExternalDetailLinkProps) => {
  const link = getExternalPackageLink(source, packageId, carId, offerId);
  const { hasRole } = useRole();

  return hasRole(UserRole.ADMIN) ? (
    <ActionTooltip title={`Direktlink ${getLabel(sources, source as string)}`} disabled={!link}>
      <IconButton disabled={!link} size={size} href={link || ''} rel="noreferrer" target="_blank">
        <OpenInNew />
      </IconButton>
    </ActionTooltip>
  ) : null;
};

export default memo(ActionExternalPackageLink);
